import React from "react";
import PropTypes from "prop-types";
import "../../assets/styles/SourceList.css";

const SourceList = ({ sources }) => {
    if (!sources || sources.length === 0) return null;

    return (
        <div className="source-list">
            <h5 className="source-list-title">Sources</h5>

            {sources.map((source, index) => (
                <div
                    key={source.document_id || index}
                    className="source-card"
                    dir="auto"
                >
                    {source.document_url && (
                        <a
                            href={source.document_url}
                            target="_blank"
                            rel="noreferrer"
                            className="source-link"
                        >
                            {source.title || "Untitled Manuscript"}
                        </a>
                    )}
                </div>
            ))}
        </div>
    );
};

SourceList.propTypes = {
    sources: PropTypes.arrayOf(
        PropTypes.shape({
            document_id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
            title: PropTypes.string,
            author: PropTypes.string,
            date_written: PropTypes.string,
            location: PropTypes.string,
            excerpt: PropTypes.string,
            document_url: PropTypes.string,
        })
    ).isRequired,
};

export default SourceList;